import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import MapWithMarkersStore from "@lib-shared/stores/map/map-with-markers.store";
import Spinner from "@menu/components/shared/spinner";
import AppConfig from "core/app-config";
import SearchStore, { defaultNumberOfResultsToShow } from "core/stores/search.store";
import BackgroundMap from "./background-map";
import CityResults from "./city-results";
import SearchInput from "./search-input";
import SearchResults from "./search-results";
import useSearchLogic from "./use-search-logic";
import NoSearchResults from "./no-search-results";

type SearchProps = {
  store: SearchStore;
  mapStore: MapWithMarkersStore;
}

const Search = observer((props: SearchProps) => {
  const { store, mapStore } = props;

  const {
    getResultsToShow,
    filterCities,
    useMyLocation,
    fetchCitiesAsync,
    clearFilter,
    selectCityAsync
  } = useSearchLogic(store, mapStore);

  useEffect(() => {
    if (!store.country || store.isLoading) {
      return;
    }

    const fetch = async () => {
      store.updateIsLoading(true);
      await fetchCitiesAsync();
      store.updateIsLoading(false);
    };

    fetch();

  }, [store.country]);

  const { contentHeader, contentSubHeader } = AppConfig;

  const showResults = !!store.totalCount && !store.isLoading;

  const searchResults = getResultsToShow();

  const showSearchInput = !!store.cities.length;

  const loadMore = () => {
    store.updateNumberOfResultsToShow(store.numberOfResultsToShow + defaultNumberOfResultsToShow);
  }

  return (
    <>
      <BackgroundMap mapStore={mapStore} />

      <div className="search-container">
        <h1>{contentHeader}</h1>

        <p>
          {contentSubHeader}
        </p>

        {showSearchInput &&
          <SearchInput
            onClick={() => {
              if (searchResults) {
                clearFilter();
              }
            }}
            hasFilter={!!store.filter}
            filterCities={filterCities}
            clearFilter={clearFilter}
            useMyLocation={useMyLocation} />}

        {!showResults && <CityResults store={store} selectCityAsync={selectCityAsync} />}

        {store.isLoading && <Spinner />}

        {store.showNoResults && <NoSearchResults store={store} />}

        {showResults && <SearchResults store={store} searchResults={searchResults} loadMore={loadMore} />}
      </div>
    </>
  );
});

export default Search;
